// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RawTokenAmount
 */
export interface RawTokenAmount {
    /**
     * 
     * @type {string}
     * @memberof RawTokenAmount
     */
    tokenAmount: string;
    /**
     * 
     * @type {number}
     * @memberof RawTokenAmount
     */
    decimals: number;
}

/**
 * Check if a given object implements the RawTokenAmount interface.
 */
export function instanceOfRawTokenAmount(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tokenAmount" in value;
    isInstance = isInstance && "decimals" in value;

    return isInstance;
}

export function RawTokenAmountFromJSON(json: any): RawTokenAmount {
    return RawTokenAmountFromJSONTyped(json, false);
}

export function RawTokenAmountFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawTokenAmount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tokenAmount': json['tokenAmount'],
        'decimals': json['decimals'],
    };
}

export function RawTokenAmountToJSON(value?: RawTokenAmount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tokenAmount': value.tokenAmount,
        'decimals': value.decimals,
    };
}

